import { theme } from '@chakra-ui/react';

export const colors = {
  brand: theme.colors.gray,
  accent: theme.colors.blackAlpha,
};
